export const placesApi = window.google?.maps.places;
export const mapsApi = window.google?.maps;

/**
 * Searches google places autocomplete api based
 * off a search term
 * @param {string} searchTerm - Term to search
 * @param {string} sessionToken - Session token for autocomplete
 * @param {func} callback - Callback function on completion
 * @return {object} - Response from network.
 */
export function searchPlaces(searchTerm, sessionToken) {
  if (!placesApi) {
    return new Promise().resolve([]);
  }

  const autocomplete = new placesApi.AutocompleteService();
  if (!autocomplete) {
    return new Promise().reject();
  }

  // Build out request paramaters
  const params = {
    input: searchTerm,
    types: ['(cities)'],
    componentRestrictions: {
      country: 'us',
    },
    sessionToken,
  };

  // Construct callback into promise
  return new Promise((resolve, reject) => {
    autocomplete.getPlacePredictions(params, (res) => {
      if (res) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
}

export function getLatLong(address) {
  if (!mapsApi) {
    return new Promise().resolve([]);
  }

  const geocoder = new mapsApi.Geocoder();
  if (!geocoder) {
    return new Promise().reject();
  }

  // Build out request paramaters
  const params = {
    address,
  };

  // Construct callback into promise
  return new Promise((resolve, reject) => {
    geocoder.geocode(params, (res) => {
      if (res) {
        resolve(res);
      } else {
        reject(res);
      }
    });
  });
}
